module.exports = __webpack_public_path__ + "static/media/income.579d104b.svg";